module.exports = __webpack_public_path__ + "img/schema 3 - EN.1db3aa77.svg";